import React from "react";
import { ASSETS } from "@/lib/assets";

export const Logo = ({ className = "", invert = false }) => (
  <a href="https://chelsealitsey.com" target="_blank" rel="noreferrer" className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <span className="block h-9 w-9 sm:h-10 sm:w-10 rounded-full overflow-hidden ring-1 ring-sage-300/60" style={{ background: invert ? "#0E0E0E" : "#0E0E0E" }}>
      <img src={ASSETS.logo} alt="Chelsea Litsey Clarity Coach" className="h-full w-full object-cover" />
    </span>
    <span className="font-display text-base sm:text-lg tracking-tight text-ink">
      Chelsea Litsey<span className="text-sage-700"> · </span><span className="italic-display text-ink/70">Clarity Coach</span>
    </span>
  </a>
);

export const TopBar = () => (
  <header className="w-full px-6 sm:px-10 lg:px-16 py-5 flex items-center justify-between">
    <Logo />
    <a
      href="https://chelsealitsey.com"
      target="_blank"
      rel="noreferrer"
      className="hidden sm:inline-flex font-sans text-sm tracking-wide text-ink/70 link-reveal"
      data-testid="visit-main-site-link"
    >
      Visit Main Site →
    </a>
  </header>
);

export const Footer = () => (
  <footer className="px-6 sm:px-10 lg:px-16 py-10 mt-16 border-t border-cream-300/60">
    <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="block h-7 w-7 rounded-full overflow-hidden bg-ink"><img src={ASSETS.logo} alt="" className="h-full w-full object-cover" /></span>
        <span className="font-display text-sm text-ink/70">© {new Date().getFullYear()} Chelsea Litsey · Clarity Coach</span>
      </div>
      <div className="font-sans text-xs tracking-widest uppercase text-ink/50">
        Nervous-system clarity for ambitious women
      </div>
    </div>
  </footer>
);
